export enum SearchbarItemType {
    All,
    Estimate,
    Costbook
}


// WEBPACK FOOTER //
// ./ClientApp/services/state/searchBarItemType.ts